import SelectCourse from './src/main';

/* istanbul ignore next */
SelectCourse.install = function(Vue) {
  Vue.component(SelectCourse.name, SelectCourse);
};

export default SelectCourse;
